// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/MemberMLM.js
import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from '../components/Header';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLocation } from 'react-router-dom';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../css/Member.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// SCSS ของ MemberMLM
import styles from '../css/MemberMLM.module.scss';

import { getSelectedLanguage } from '../api/api';      // <-- เพิ่ม
import { languageManager } from '../utils/loadLanguage'; // <-- เพิ่ม

import { API_URLS } from '../api/api';
import OrgChartComponent from '../components/OrgChartComponent';

const MemberMLM = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialUserId = queryParams.get('userId') || localStorage.getItem('user_ID') || 57;

    const [searchQuery, setSearchQuery] = useState('');
    const [nodes, setNodes] = useState(null);
    const [history, setHistory] = useState([initialUserId]);
    const [zoom, setZoom] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalMembers, setTotalMembers] = useState(0);

    const token = localStorage.getItem('token');

    // State สำหรับเก็บข้อความ (translations) ของ memberMLM
    const [t, setT] = useState({}); 

    // โหลดภาษา (JSON) ตามค่าที่ผู้ใช้เลือก
    useEffect(() => {
        async function loadLang() {
            const lang = getSelectedLanguage();    // e.g. 'th' or 'en'
            await languageManager.loadLanguage(lang);
            // ดึงเฉพาะส่วน memberMLM จาก JSON
            setT(languageManager.translations.memberMLM || {});
        }
        loadLang();
    }, []);

    // ฟังก์ชันนับ Node ลูกทั้งหมด
    const countNodes = (node) => {
        if (!node) return 0;
        let count = 1;
        if (node.children) {
            for (let child of node.children) {
                count += countNodes(child);
            }
        }
        return count;
    };

    const refreshData = () => {
        loadOrgData(initialUserId);
    };

    const loadOrgData = async (userId) => {
        setLoading(true);
        try {
            const response = await fetch(`${API_URLS.ORG_DATA(userId)}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch organization data: ${response.statusText}`);
            }

            const data = await response.json();
            if (data && data.length > 0) {
                setNodes(data);
                setTotalMembers(countNodes(data[0]));
            } else {
                console.log('No data received:', data);
                setNodes([]);
                setTotalMembers(0);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setNodes([]);
            setTotalMembers(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadOrgData(initialUserId);
        // eslint-disable-next-line
    }, [initialUserId, token]);

    const handleClick = async (userId) => {
        setHistory((prevHistory) => [...prevHistory, userId]);
        await loadOrgData(userId);
    };

    const handleBack = async () => {
        setHistory((prevHistory) => {
            const newHistory = [...prevHistory];
            newHistory.pop();
            const previousUserId = newHistory[newHistory.length - 1] || initialUserId;
            loadOrgData(previousUserId);
            return newHistory;
        });
    };

    const handleZoomIn = () => {
        setZoom((prevZoom) => prevZoom + 0.1);
    };

    const handleZoomOut = () => {
        setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.1));
    };

    return (
        <div className="dashboard">
            <Sidebar />
            <div className="dashboard-main">
                <Header
                    onBack={handleBack}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    refreshData={refreshData}
                />

                {/* ถ้า loading = true -> แสดง spinner แบบเต็มจอ */}
                {loading && (
                    <div className={styles["spinner-container"]}>
                        <ProgressSpinner
                            style={{ width: '50px', height: '50px' }}
                            strokeWidth="8"
                            fill="var(--surface-ground)"
                            animationDuration=".5s"
                        />
                    </div>
                )}

                <div className="member-table-container">
                    {/* ใช้ข้อความจาก JSON ถ้าไม่มี key ก็ fallback */}
                    <h1>{t.chartTitle || "MLM Organization Chart"}</h1>

                    <div className={styles["zoom-controls"]}>
                        <button onClick={handleZoomIn} className="p-button p-component p-button-icon-only">
                            <span className="pi pi-search-plus"></span>
                        </button>
                        <button onClick={handleZoomOut} className="p-button p-component p-button-icon-only">
                            <span className="pi pi-search-minus"></span>
                        </button>
                    </div>

                    {/* ถ้าไม่ loading -> แสดง OrgChart */}
                    {!loading && (
                        <div style={{ transform: `scale(${zoom})`, transformOrigin: 'top left' }}>
                            <OrgChartComponent
                                nodes={nodes}
                                totalMembers={totalMembers}
                                onNodeClick={handleClick}
                            />
                        </div>
                    )}

                    {/* ถ้าไม่มี node -> แสดงข้อความ fallback */}
                    {!loading && (!nodes || nodes.length === 0) && (
                        <div>{t.noData || "No organization data found"}</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MemberMLM;
